import { ExpandableSection } from "routes/skus/components/expandable-section";
import Spinner from "../../../components/Spinner";
import { DateTimeFormat } from "../../../libraries/date-time-format/date-time-format";
import { Predicates } from "../../../libraries/predicates/predicates";

export const ArtworkRequestHistoryTable = (props: {
  historyRecords: any[];
  isLoading?: boolean;
}) => {
  const statusOrder = {
    APPROVED: 1,
    REJECTED: 2,
    SUBMITTED: 3,
    CREATED: 4,
  };

  return (
    <div className="mt-3">
      <ExpandableSection
        sectionId={"tcc-view-request-history"}
        title="Request History"
        expandedByDefault={true}
      >
        <div className="molds-table-container">
          {props.isLoading ? (
            <Spinner />
          ) : (
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th scope="col">Status</th>
                  <th scope="col">Timestamp</th>
                  <th scope="col">User</th>
                  <th scope="col">User Location</th>
                  <th scope="col">Comment</th>
                </tr>
              </thead>
              <tbody>
                <tr></tr>
                {props.historyRecords
                  .sort((a, b) => {
                    // @ts-ignore
                    const aPriority = statusOrder[a.status.name];
                    // @ts-ignore
                    const bPriority = statusOrder[b.status.name];

                    // Compare the priorities
                    return aPriority - bPriority;
                  })
                  .map((history: any, index) => {
                    const userKey = "requester";

                    const user = history[userKey];
                    const comment =
                      Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                        history.comment,
                      )
                        ? history.comment
                        : "";

                    return (
                      <tr key={index}>
                        <td>{`${history.status.name}`}</td>
                        <td>{DateTimeFormat.formatTimestamp(history.date)}</td>
                        <td>{`${user?.first_name} ${user?.last_name}`}</td>
                        <td>{user?.location?.name}</td>
                        <td>{comment}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          )}
        </div>
      </ExpandableSection>
    </div>
  );
}

